<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Condicionante</h6>
            </div>
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Data</h6>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="row" *ngFor="let analise of analisesList">
            <div class="col-sm-2 col-12">
                <p>{{analise.siglaCondicionante}}</p>
            </div>
            <div class="col-sm-2 col-12">
                <p>{{analise.dataUltimaAtualizacao | date: 'dd/MM/yyyy'}}</p>
            </div>
        </div>
    </div>
</div>